module.exports = __webpack_public_path__ + "img/58_7.8b6eaf3e.png";